import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PaginationInstance } from 'ngx-pagination';
import { CategoryService } from 'src/app/services/category.service';

@Component({
  standalone: false,
  selector: 'app-categories-list',
  templateUrl: './categories-list.component.html',
})
export class CategoriesListComponent implements OnInit {
  items: any[] = [];
  paginationConfig: PaginationInstance = {
    id: 'categories_listing',
    itemsPerPage: 10,
    totalItems: 0,
    currentPage: 1,
  };

  constructor(
    private categoryService: CategoryService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.loadItems();
  }

  loadItems(): void {
    this.categoryService.list().subscribe({
      next: (result) => {
        this.items = result?.data?.categories ?? [];
        this.paginationConfig.totalItems = this.items.length;
        this.clampPage();
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to load categories.');
      },
    });
  }

  onPageChange(page: number): void {
    this.paginationConfig.currentPage = page;
  }

  statusLabel(status: number): string {
    return status === 1 ? 'Active' : status === 2 ? 'Inactive' : String(status ?? '-');
  }

  private clampPage(): void {
    const perPage = this.paginationConfig.itemsPerPage || 10;
    const maxPage = Math.max(1, Math.ceil((this.paginationConfig.totalItems ?? 0) / perPage));
    const current = this.paginationConfig.currentPage ?? 1;
    this.paginationConfig.currentPage = Math.min(Math.max(1, current), maxPage);
  }
}
